import GameStepBase from '../../game_step_base';

import GameBodyInIframeComponent from '../../../../../components/game_body/game_body_in_iframe_component';

export default class BuildGameBodyGameStep extends GameStepBase {
    static CLASS = 'BuildGameBodyGameStep';

    init(params) {
        super.init(params);
        if (!params.getGameUrlCallback) {
            this.throwArgumentExpected('11', 'init', 'getGameUrlCallback');
        }

        this._getGameUrlCallback = params.getGameUrlCallback;
        this._allowFullScreen = params.allowFullScreen;
        this.additionalCssClasses = params.additionalCssClasses || [];
        this._allowScrolling = params.allowScrolling;
    }

    run(gameOptions) {
        return this._getGameUrlCallback(gameOptions)
            .then(gameUrl => {
                const params = {
                    gameUrl: gameUrl,
                    isResizable: gameOptions.isResizable,
                    gameSize: gameOptions.gameSize,
                    regulationStripe: gameOptions.gameRegulationStripe,
                    gameProviderCssClassName: gameOptions.gameProviderCssClassName,
                    additionalCssClasses: this.additionalCssClasses,
                    allowFullScreen: this._allowFullScreen,
                    allowScrolling: this._allowScrolling,
                    gameType: gameOptions.gameType,
                    gameGroupId: gameOptions.gameInfo.gameGroupId
                };

                const gameBody = this._createGameBodyComponent(params);
                return Object.assign(gameOptions, {
                    gameBody: gameBody
                });
            });
    }

    _createGameBodyComponent(params) {
        return GameBodyInIframeComponent.create(params);
    }
}